import nflow from './nflow'
if (global) global.nflow = global.nFlow = nflow // nFlow is now deprecated
module.exports = nflow



// WEBPACK FOOTER //
// ./src/index.js